export const CATEGORIES = [
  "Rice & Paddy Products",
  "Pulses & Lentils",
  "Maize & Cereals",
  "Millets",
  "Spices",
  "Oilseeds",
  "Other Agricultural Commodities",
];

export const AVAILABILITY = [
  "Regular Supply",
  "Available on Request",
  "Seasonal Availability",
  "Sourcing Required",
];

export const AVAILABILITY_STYLES = {
  "Regular Supply": "bg-emerald-50 text-emerald-800 border-emerald-200",
  "Available on Request": "bg-amber-50 text-amber-800 border-amber-200",
  "Seasonal Availability": "bg-sky-50 text-sky-800 border-sky-200",
  "Sourcing Required": "bg-stone-100 text-stone-800 border-stone-300",
};
